/** Ephemeral network DSD delivery label (#1138) — avoids bloating maestroStore. */

let label: string | null = null;

export function getPlaybackNetworkFormatLabel(): string | null {
  return label;
}

export function setPlaybackNetworkFormatLabel(next: string | null): void {
  label = next?.trim() || null;
}

export function clearPlaybackNetworkFormatLabel(): void {
  label = null;
}
